'use client';

import dynamic from 'next/dynamic';
import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
import MetaTags from '@/components/meta-tag/meta-tag';
import TechnologyFaq from '@/components/technologies/technology-faq';
import Blog from '@/components/home/blog';
import HireProcessAimlDev from '@/components/technologies/hire-process-aimldev';
import StrategicAiConsulting from '@/components/common/strategic-ai-consulting';
import ValuePropositionAiStrategy from '@/components/common/value-proposition-ai-strategy';
import WhyAiStrategy from '@/components/common/why-ai-strategy';
import OurOfferingAiStrategy from '@/components/common/our-offering-ai-strategy';
import TechnicalApproachAiStrategy from '@/components/common/technical-approach-ai-strategy';
import ArchitectureDiagramAiStrategy from '@/components/common/architecture-diagram-ai-strategy';
import IntegrationsTechAiStrategy from '@/components/common/integrations-tech-ai-strategy';
import AiStrategyFAQ from '@/components/faqs/ai-strategy-faq';
import AiStrategyTechStack from '@/components/home/ai-strategy-tech-stack';

const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));
const TechHeroAiStrategyConsulting = dynamic(() => import('@/components/technologies/tech-hero-ai-strategy-consulting'));

const Page = () => {
    return (
        <>
            <MetaTags />
            <div className="dark:bg-black">
                <TechHeroAiStrategyConsulting />
                <StrategicAiConsulting />
                <ValuePropositionAiStrategy />
                <WhyAiStrategy />
                <OurOfferingAiStrategy />
                <TechnicalApproachAiStrategy />
                <ArchitectureDiagramAiStrategy />
                <IntegrationsTechAiStrategy />
                <AiStrategyTechStack />
                <HireProcessAimlDev
                    bg="bg-black"
                    pageTitle="Our AI/ML Development Process"
                    desc="Maximize the possibilities of the newest AI/ML version. You can hire our AI/ML developers, who are competent in the technical and interactive abilities required to meet your project's objectives."
                />
                <TechnologyFaq title="FAQs for AI Strategy & Consulting" bg="bg-aiml-faq">
                    <AiStrategyFAQ />
                </TechnologyFaq>
                <CaseStudies />
                <section className="">
                    <ClientTestimonials />
                </section>
                <Blog />
                <div className="section bg-primary py-100 dark:text-light dark:bg-black dark:pt-1">
                    <div className="container lg:container md:mx-auto">
                        <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                            <ContactForm />
                            <ContactInfo />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
